<template>
  <div class="empty-page-placeholder">
    <Text variant="h3">{{ props.title }}</Text>
    <Text variant="body-large">{{ props.description }}</Text>
  </div>
</template>

<script setup lang="ts">
import Text from './text.vue';

const props = defineProps<{
  title: string;
  description: string;
}>();
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.empty-page-placeholder {
  text-align: center;
  width: 100%;
  max-width: 37.5rem;
  margin: var(--t-spacing-xxl) auto 0;

  p {
    padding-top: var(--t-spacing-md);
  }
}
</style>
